// Firm-aware app/share icon + title. On firm tenant + client-portal pages we
// show the firm's uploaded logo and an appropriate name; everywhere else (and
// when a firm has none) we fall back to the Lexarra (LX) logo/name. iOS
// "Add to Home Screen" reads the <title>, apple-mobile-web-app-title AND the
// web app manifest, so we keep all three in sync (the manifest is what modern
// iOS/Android actually use for the installed name + icon).
const LX = "/lexarra-logo.png";
let _manifestUrl = null;

function abs(href) {
  try { return new URL(href, window.location.origin).href; } catch (e) { return href; }
}
function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
  el.setAttribute("href", href);
}
function upsertMeta(key, val, attr = "property") {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", val);
}
// The index.html ships several static <link rel="icon"> tags (.ico + 16/32 png).
// Browsers pick among them, so updating just one won't change the tab favicon.
// Clear them all and set a single icon so the firm logo actually wins.
function setFavicon(href) {
  document.head.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]').forEach((el) => el.remove());
  const l = document.createElement("link");
  l.setAttribute("rel", "icon");
  l.setAttribute("href", href);
  document.head.appendChild(l);
}
function setManifest(title, iconHref, start) {
  try {
    // Emit a self-contained data-URL manifest whose start_url is the EXACT page.
    // iOS caches the manifest referenced by URL aggressively (so a previously-saved
    // root start_url sticks); a data URL changes with its content, sidestepping that
    // and guaranteeing "Add to Home Screen" saves the page the user is actually on.
    const s = abs(start || (window.location.pathname + window.location.search) || "/");
    const m = {
      short_name: title,
      name: title,
      icons: [
        { src: iconHref, sizes: "192x192", type: "image/png" },
        { src: iconHref, sizes: "512x512", type: "image/png" },
      ],
      start_url: s,
      scope: "/",
      display: "standalone",
      theme_color: "#050505",
      background_color: "#050505",
    };
    const href = "data:application/manifest+json;charset=utf-8," + encodeURIComponent(JSON.stringify(m));
    upsertLink("manifest", href);
  } catch (e) { /* noop */ }
}

export function firmIcon(logoUrl, slug) {
  // Always route a firm's home-screen/manifest icon through the backend endpoint: it
  // converts any uploaded logo into a square PNG iOS accepts and falls back to a branded
  // monogram. ?v= changes with the logo so iOS never reuses a stale icon.
  if (slug) { let h = 0; for (const ch of (logoUrl || "").slice(-400)) h = (h * 31 + ch.charCodeAt(0)) | 0; return `/api/public/firm/${slug}/icon?v=${(logoUrl || "").length}-${Math.abs(h)}`; }
  return logoUrl || null;
}

export function applyAppIcon(url, name, start) {
  try {
    const href = abs(url || LX);
    const title = name || "Lexarra";
    upsertLink("apple-touch-icon", href);
    setFavicon(href);
    upsertMeta("og:image", href);
    upsertMeta("twitter:image", href, "name");
    // Home-screen / share title
    upsertMeta("apple-mobile-web-app-title", title, "name");
    upsertMeta("application-name", title, "name");
    upsertMeta("og:title", title);
    upsertMeta("twitter:title", title, "name");
    try { document.title = title; } catch (e) { /* noop */ }
    // Modern iOS/Android use the manifest for the installed name + icon.
    setManifest(title, href, start);
  } catch (e) { /* never let icon/title updates crash the app */ }
}
